module.exports = __webpack_public_path__ + "static/media/lock-img-icon.cb3f1eff.png";